/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useCallback, useMemo } from 'react';
import { FunctionComponent } from 'react';
import Loader from 'react-loader-spinner';
import { useDispatch } from 'react-redux';
import { closeDialog } from '../../../app/dialog/dialog.actions';
import { dialogSelectors } from '../../../app/dialog/dialog.selectors';
import { useApiRequestState } from '../../../utils/api.utils';
import { useSelectWithParams } from '../../../utils/selector.utils';
import { NodeForm } from '../../pages/common/forms/NodeForm';
import { SubmitButton } from '../../pages/common/forms/SubmitButton';
import { ConnectedDialog } from '../ConnectedDialog';
import { INodeFormDialogProps } from './types';

export const NodeFormDialog: FunctionComponent = () => {
  const dispatch = useDispatch();

  const props = useSelectWithParams(dialogSelectors.selectDialogProps, 'nodeFormDialog') as INodeFormDialogProps;

  const isEditForm = props?.nodeData ? true : false;

  const [showLoader, error] = useApiRequestState(isEditForm ? 'updateNode' : 'createNode');

  const onClose = useCallback(() => {
    dispatch(closeDialog('nodeFormDialog'));
  }, [dispatch]);

  const title = useMemo(() => (props && props.nodeData ? 'Edit Seat' : 'Add Seat'), [props]);
  return (
    <ConnectedDialog dialogKey="nodeFormDialog">
      <div className="popup new_todo_popup" style={{ display: 'block' }}>
        <div className="panel">
          <div className="panel-header small-header flex jcsb">
            {title}
            <span className="close-popup close" onClick={onClose}>
              {!error && !showLoader && <i className="icon-close" />}
              {showLoader && <Loader type="TailSpin" color="var(--theme-primary-color)" height={20} width={20} />}
              {error && !showLoader && <p style={{ color: 'red' }}> Something went wrong </p>}
            </span>
          </div>
          <div className="panel-body" style={{ maxHeight: '619.1px' }}>
            <NodeForm {...props} />
          </div>
          <div className="panel-footer no-border flex jcr">
            <a className="link blueGray mr-2 close" onClick={onClose}>
              Close
            </a>

            {isEditForm ? (
              <SubmitButton apiKey="updateNode" formName="node-form" text="Update" />
            ) : (
              <SubmitButton apiKey="createNode" formName="node-form" text="Create" />
            )}
          </div>
        </div>
      </div>
    </ConnectedDialog>
  );
};
